import { axiosInstance } from "../../../@core/auth/jwt/jwtService";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const getTicketsById = createAsyncThunk(
  "tickets/getTicketsById",
  async (args, thunkAPI) => {
    const { eventId, id } = args;
    try {
      const response = await axiosInstance.request({
        url: `/events/${eventId}/tickets/${id}`,
        method: "get",
      });
      return { data: response.data };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        "Error al consultar los tickets. Error: ",
        error.response.status
      );
    }
  }
);

export const getTickets = createAsyncThunk(
  "tickets/getTickets",
  async (args, thunkAPI) => {
    const {
      type,
      status,
      eventId,
      orderBy,
      pageSize,
      pageNumber,
      searchQuery,
    } = args;
    try {
      const response = await axiosInstance.request({
        url: `/events/${eventId}/tickets`,
        method: "get",
        params: { pageSize, pageNumber, searchQuery, status, orderBy, type },
      });

      return { data: response };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        "Error al consultar los tickets. Error: ",
        error
      );
    }
  }
);

export const getAddonsOfTickets = createAsyncThunk(
  "tickets/getAddonsOfTickets",
  async ({ eventId, ticketId }, thunkAPI) => {
    try {
      const response = await axiosInstance.request({
        url: `/events/${eventId}/tickets/${ticketId}/addons`,
        method: "get",
      });

      return { data: response.data };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        "Error al consultar los tickets. Error: ",
        error
      );
    }
  }
);

export const getAllTickets = createAsyncThunk(
  "tickets/getAllTickets",
  async (eventId, thunkAPI) => {
    try {
      const response = await axiosInstance.request({
        url: `/${eventId}/tickets/export`,
        method: "get",
      });
      return { data: response.data };
    } catch (err) {
      return thunkAPI.rejectWithValue(
        "Error al consultar los tickets. Error: ",
        err.message
      );
    }
  }
);

export const getTicketsToExport = createAsyncThunk(
  "tickets/getTicketsToExport",
  async (args, thunkAPI) => {
    const { eventId, status, type } = args;
    const response = await axiosInstance.request({
      url: `/events/${eventId}/tickets/export`,
      method: "get",
      params: { status, type },
    });
    return { data: response };
  }
);

export const validateEmail = createAsyncThunk(
  "tickets/validateEmail",
  async (validationData, thunkAPI) => {
    const { eventId, email } = validationData;
    const response = await axiosInstance.request({
      url: `/events/${eventId}/checkout/validateEmail`,
      method: "post",
      data: { email },
    });
    return { data: response };
  }
);

export const validateCustomField = createAsyncThunk(
  "tickets/validateCustomField",
  async (fieldData, thunkAPI) => {
    const { eventId, field, customFieldId } = fieldData;
    const response = await axiosInstance.request({
      url: `/events/${eventId}/checkout/validateField`,
      method: "post",
      data: field,
    });
    return { data: response, customFieldId };
  }
);

export const setTicket = createAsyncThunk(
  "tickets/setTicket",
  async (fieldData, thunkAPI) => {
    const { eventId, data } = fieldData;
    const response = await axiosInstance.request({
      url: `/events/${eventId}/tickets`,
      method: "post",
      data,
    });
    return { data: response };
  }
);

export const updateTicket = createAsyncThunk(
  "tickets/updateTicket",
  async (args, thunkAPI) => {
    const { id, eventId, data } = args;
    const response = await axiosInstance.request({
      url: `/events/${eventId}/tickets/${id}`,
      method: "patch",
      data,
    });
    return { data: response };
  }
);

export const downloadTicket = createAsyncThunk(
  "tickets/downloadTicket",
  async (args, thunkAPI) => {
    const { eventId, firstName, lastName, email, ticketId } = args;
    const response = await axiosInstance.request({
      url: `events/${eventId}/tickets/${ticketId}/download`,
      method: "get",
      responseType: "blob",
    });
    return { data: response.data, firstName, lastName };
  }
);

export const sendTicket = createAsyncThunk(
  "tickets/sendTicket",
  async (args, thunkAPI) => {
    const { data, ticketId, eventId } = args;
    const response = await axiosInstance.request({
      url: `/events/${eventId}/tickets/${ticketId}/send`,
      method: "post",
      data,
    });
    return { data: response };
  }
);

export const deleteTicket = async (id, eventId) => {
  await axiosInstance.delete(`/events/${eventId}/tickets/${id}`, "");
};

export const importMassive = createAsyncThunk(
  "tickets/importMassive",
  async (validationData, thunkAPI) => {
    const { eventId, sendEmail, data } = validationData;
    const response = await axiosInstance.request({
      url: `/events/${eventId}/tickets/collection`,
      method: "post",
      data: data,
      params: { sendEmail },
    });
    return { data: response };
  }
);

export const ticketsSlice = createSlice({
  name: "tickets",
  initialState: {
    list: [],
    addons: [],
    listId: [],
    headers: [],
    totalRows: 0,
    pending: false,
    hiddeTab: false,
    hideSubs: false,
    unmapped: false,
    inputSearch: "",
    hideEmail: false,
    listToExport: [],
    loadingStatus: "",
    userCodeStatus: 0,
    addonsToSelect: [],
    pendingById: false,
    pendingSend: false,
    userCodeData: null,
    pendingaddons: false,
    pendingImport: false,
    pendingExport: false,
    pendingCreate: false,
    pendingUpdate: false,
    fieldsToValidate: [],
    emailValidationList: [],
  },
  reducers: {
    setHideEmail: (state, action) => {
      state.hideEmail = action.payload;
    },
    setHideSubs: (state, action) => {
      state.hideSubs = action.payload;
    },
    setUnmapped: (state, action) => {
      state.unmapped = action.payload;
    },
    setHiddeTab: (state, action) => {
      state.hiddeTab = action.payload;
    },
    setTicketsList: (state, action) => {
      state.list = action.payload;
    },
    setHeadersList: (state, action) => {
      state.headers = action.payload;
    },
    addFieldToValidate: (state, action) => {
      state.fieldsToValidate = [...state.fieldsToValidate, action.payload];
    },
    setCustomFieldStatus: (state, action) => {
      const { customFieldId, status } = action.payload;
      const founded = state.fieldsToValidate.find(
        (field) => (field.id = customFieldId)
      );

      if (founded) {
        founded.status = status;
      }
    },
    clearFieldsToValidate: (state) => {
      state.fieldsToValidate = [];
    },
    setInputSearch: (state, action) => {
      state.inputSearch = action.payload;
    },
    addEmailValidation: (state, action) => {
      state.emailValidationList = [
        ...state.emailValidationList,
        action.payload,
      ];
    },
    setEmailValidation: (state, action) => {
      const { ticketId, status } = action.payload;
      const founded = state.emailValidationList.find(
        (email) => email.ticketId === ticketId
      );

      if (founded) {
        founded.status = status;
      }
    },
    clearTicketValidations: (state) => {
      state.emailValidationList = [];
      state.fieldsToValidate = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTickets.fulfilled, (state, action) => {
        const { data } = action.payload;
        const keys = [];
        data?.data.forEach((e, i) => {
          if (e?.customFields) {
            keys.push(e?.customFields);
          }
        });

        const result = [...new Set(keys.flatMap(Object.keys))];
        state.headers = result;
        state.list = data;
        state.pending = false;
        state.loadingStatus = "succeeded";
        state.totalRows = JSON.parse(data?.headers["x-pagination"]).totalCount;
      })
      .addCase(getTickets.rejected, (state, action) => {
        state.loadingStatus = "failed";
        state.list = [];
        state.pending = false;
      })
      .addCase(getTickets.pending, (state, action) => {
        state.pending = true;
      })
      .addCase(getTicketsById.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.listId = data;
        state.pendingById = false;
      })
      .addCase(getTicketsById.pending, (state) => {
        state.pendingById = true;
      })
      .addCase(getTicketsById.rejected, (state) => {
        state.pendingById = true;
      })
      .addCase(getTicketsToExport.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.listToExport = data.data;
        state.pendingExport = false;
      })
      .addCase(getTicketsToExport.pending, (state) => {
        state.pendingExport = true;
      })
      .addCase(getTicketsToExport.rejected, (state) => {
        state.pendingExport = false;
      })
      .addCase(getAllTickets.fulfilled, (state, action) => {
        const customs = action.payload.data;
        const keys = [];

        customs.forEach((e, i) => {
          if (e.attendee.customFields) {
            keys.push(e.attendee.customFields);
          }
        });
        const result = [...new Set(keys.flatMap(Object.keys))];
        state.headers = result;
      })
      .addCase(getAllTickets.rejected, (state) => {
        state.loadingStatus = "failed";
      })
      .addCase(validateEmail.fulfilled, () => {})
      .addCase(validateEmail.rejected, () => {})
      .addCase(validateCustomField.fulfilled, (state, action) => {})
      .addCase(validateCustomField.rejected, () => {})
      .addCase(importMassive.fulfilled, (state, action) => {
        state.pendingImport = false;
      })
      .addCase(importMassive.pending, (state) => {
        state.pendingImport = true;
      })
      .addCase(importMassive.rejected, (state) => {
        state.pendingImport = true;
      })
      .addCase(setTicket.fulfilled, (state, action) => {
        state.pendingCreate = false;
      })
      .addCase(setTicket.pending, (state) => {
        state.pendingCreate = true;
      })
      .addCase(setTicket.rejected, (state) => {
        state.pendingCreate = false;
      })
      .addCase(updateTicket.fulfilled, (state, action) => {
        state.pendingUpdate = false;
      })
      .addCase(updateTicket.pending, (state) => {
        state.pendingUpdate = true;
      })
      .addCase(updateTicket.rejected, (state) => {
        state.pendingUpdate = false;
      })
      .addCase(getAddonsOfTickets.fulfilled, (state, action) => {
        state.pendingaddons = false;
        const { data } = action.payload;
        state.addons = data;
      })
      .addCase(getAddonsOfTickets.pending, (state) => {
        state.pendingaddons = true;
      })
      .addCase(getAddonsOfTickets.rejected, (state) => {
        state.pendingaddons = false;
      })
      .addCase(sendTicket.fulfilled, (state, action) => {
        state.pendingSend = false;
      })
      .addCase(sendTicket.pending, (state) => {
        state.pendingSend = true;
      })
      .addCase(sendTicket.rejected, (state) => {
        state.pendingSend = false;
      })
      .addCase(downloadTicket.fulfilled, (state, action) => {
        if (action.payload.data) {
          const { data, firstName, lastName } = action.payload;
          state.userCodeData = data;
          state.userCodeStatus = 1;

          const urlFile = window.URL.createObjectURL(new Blob([data]));
          const fileName = `${firstName} ${lastName}.pdf`;
          const link = document.createElement("a");
          link.setAttribute("href", urlFile);
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
        } else {
          state.userCodeStatus = 2;
        }
      })
      .addCase(downloadTicket.pending, (state) => {
        state.userCodeData = null;
        state.userCodeStatus = -1;
      })
      .addCase(downloadTicket.rejected, (state) => {
        state.userCodeStatus = 2;
      });
  },
});

export const {
  setHiddeTab,
  setUnmapped,
  setHideSubs,
  setHideEmail,
  setTicketsList,
  setHeadersList,
  setInputSearch,
  addFieldToValidate,
  addEmailValidation,
  setEmailValidation,
  setCustomFieldStatus,
  clearFieldsToValidate,
  clearTicketValidations,
} = ticketsSlice.actions;

export default ticketsSlice.reducer;
